
  import { Component, Vue } from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import FeedbackForm from "@/modules/Support/components/FeedbackForm.vue";

  @Component({
    components: {
      AppDialog,
      FeedbackForm,
    }
  })
  export default class FeedbackPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'allPages', dialogName: 'feedbackPopup' };
    animateDisplay = false;

    get payloadPopup() { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

    sendMessage() {
      this.$refs.feedbackForm.sendMessage();
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }
  }
